import { RootState } from '@/store/store';
import { ResultDataState } from '@/store/types/resultTypes';
import { createSelector } from '@reduxjs/toolkit';

export const selectResultData = (state: RootState): ResultDataState => state.result.resultData;
export const selectResult = (state: RootState) => state.result;

export const selectResultError = createSelector(
	[selectResult],
	(result) => result.error
);

export const selectResultIsFetching = createSelector(
	[selectResult],
	(result) => result.isFetching
);

export const selectTestTitle = createSelector(
	[selectResultData],
	(resultData) => resultData.test.name
);

export const selectResultTestId = createSelector(
	[selectResultData],
	(resultData) => resultData.test.id
);

export const selectResultTestUrl = createSelector(
	[selectResultData],
	(resultData) => resultData.test.url
);


export const selectResultBackground = createSelector(
	[selectResultData],
	(resultData) => resultData.test.theme
);

export const selectResultDescription = createSelector(
	[selectResultData],
	(resultData) => resultData.attempt.results
);

export const selectResultHeader = createSelector(
	[selectResultData],
	(resultData) => resultData.test.result_header
);

export const selectResultFooter = createSelector(
	[selectResultData],
	(resultData) => resultData.test.result_footer
);

export const selectResultRecommendations = createSelector(
	[selectResultData],
	(resultData) => resultData.recommend_for_you
);

export const selectBlocks = createSelector(
	[selectResultData],
	(resultData) => resultData.blocks
);

export const selectIsUserAuth = createSelector(
	[selectResultData],
	(resultData) => resultData.user.auth
);

export const selectUserEmail = createSelector(
	[selectResultData],
	(resultData) => resultData.user.email
);

export const selectIsTestHasBeenModified = createSelector(
	[selectResultData],
	(resultData) => resultData.attempt.show_soft_404
);

export const selectMyDuration = createSelector(
	[selectResultData],
	(resultData) => resultData.attempt.duration_attempt_time
);

export const selectUsersAvgDuration = createSelector(
	[selectResultData],
	(resultData) => resultData.attempt.avg_attempt_time
);

export const selectIncorrectAnswers = createSelector(
	[selectResultData],
	(resultData) => resultData.incorrect_answers
);

export const selectDeviceCountry = createSelector(
	[selectResultData],
	(resultData) => resultData.device.country
);

export const selectIsApp = createSelector(
	[selectResultData],
	(resultData) => resultData.device.app
);

